module.exports = __webpack_public_path__ + "public/images/lightbulb.fa5b5b91a2f2603d63e664d0e9394f6d.svg";